import React from 'react'
import PropTypes from 'prop-types'
import { prismicHelpers } from '../../helpers'
import { Container, Link } from '../core'
import { DeseretBookComLogo } from '../core/icons'
import { Level, Menu, MenuList } from '../bulma'

/**
* Bottom Portion of site footer. `items` prop contains links in right hand
* portion of the bottom of the footer.
*/
const FooterBottomContent = props => (
  <section className="bottom-content">
    <Container isFullwidth>
      <Level>
        <div className="legal has-text-centered-mobile">
          <DeseretBookComLogo />
          <span>© 1996-{ new Date().getFullYear() } Deseret Book Company. All Rights Reserved.</span>
        </div>
        <Menu isInverted={props.isInverted} className="has-text-centered-mobile has-text-right-tablet">
          <MenuList isHorizontal isDivided isJustifiedRight className="is-size-xs">
            { props.items.map((item, idx) => {
                const viewableClass = prismicHelpers.formatViewClasses(item)

                return (
                  <li className={viewableClass} key={idx}>
                    <Link
                      href={item.link}
                      linkRef={`fb-${idx + 1}`}
                      aria-label={item.linkLabel || item.linkText}
                      target={item.target}
                      trackEvent
                      eventCategory="Footer"
                      eventAction="Bottom Bar"
                      eventLabel={item.linkText}
                      eventValue={idx + 1}
                    >
                      { item.linkText }
                    </Link>
                  </li>
                )
              }) }
          </MenuList>
        </Menu>
      </Level>
    </Container>
  </section>
)

FooterBottomContent.defaultProps = {
  items: [],
  isInverted: false,
}

FooterBottomContent.propTypes = {
  items: PropTypes.array,
  isInverted: PropTypes.bool,
}

export default FooterBottomContent
